import React from 'react';
import { 
  Button,
  makeStyles,
  tokens,
  Text
} from '@fluentui/react-components';

const useStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '60vh',
    rowGap: tokens.spacingVerticalM,
    textAlign: 'center'
  },
  description: {
    maxWidth: '600px',
    color: tokens.colorNeutralForeground2,
    lineHeight: '1.6'
  },
  descriptionContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    rowGap: tokens.spacingVerticalM
  }
});

interface ErrorStateProps {
  title: string;
  description: string | React.ReactNode;
  action?: {
    label: string;
    onClick: () => void;
  };
}

export const ErrorState: React.FC<ErrorStateProps> = ({ title, description, action }) => {
  const styles = useStyles();
  return (
    <div className={styles.container}>
      <Text size={600} weight="semibold">{title}</Text>
      <div className={styles.descriptionContent}>
        {typeof description === 'string' ? (
          <Text size={400} className={styles.description}>{description}</Text>
        ) : (
          <div className={styles.description}>{description}</div>
        )}
      </div>
      {action && (
        <Button appearance="primary" onClick={action.onClick}>{action.label}</Button>
      )}
    </div>
  );
};
